/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./BulletItem.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-bulletItem");
exports.BulletItem = function BulletItem(_a) {
    var children = _a.children, image = _a.image, nmb = _a.number, className = _a.className, props = tslib_1.__rest(_a, ["children", "image", "number", "className"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), className) }, props),
        React.createElement("div", { className: moduleClassName("bullet") }, nmb),
        !!image && React.createElement("img", tslib_1.__assign({}, image)),
        React.createElement("div", { className: moduleClassName("label") }, children)));
};
exports.BulletItem.propTypes = {
    image: PropTypes.object,
    number: PropTypes.number,
    className: PropTypes.string
};